import lazyWithRetry from 'tools/lazyWithRetry';

const component = lazyWithRetry(() => import(
	/* webpackChunkName: "VehicleTypeListPage" */
	'pages/vehicle/VehicleType/VehicleTypeListPage'));

export default [{ component, exact: true, path: '/vehicle_types' }];